import { useRouter } from 'next/router';

export const useCaseInsensitiveParam = (targetKey: string) => {
  const { query } = useRouter();

  for (const key in query) {
    if (key.toLowerCase() === targetKey.toLowerCase()) {
      return query[key] as string;
    }
  }
  return null;
};